import * as React from 'react';
import { useDispatch, useStore } from 'react-redux';
import { packageContext } from '../../contexts/package/packageContext';
import { useResponsive } from '../../hooks/useResponsive';
import { closeBuyPackageModal } from '../../slices';
import { TAppState, TDispatch } from '../../types';
import { BuyResultModal } from './BuyResultModal';
import { paymentModalClose } from '../../services/event/paymentModalClose';

export const BuyResultModalContainer = () => {
  const { isMobile } = useResponsive();
  const { getState } = useStore<TAppState>();

  const dispatch = useDispatch<TDispatch>();

  const handleClose = React.useCallback(() => {
    const state = getState();
    packageContext.trackCancel(state);

    dispatch(closeBuyPackageModal());
    paymentModalClose();
  }, [dispatch, getState]);

  return <BuyResultModal isMobile={isMobile} onClose={handleClose} />;
};
